// extracted by mini-css-extract-plugin
export var center = "_j-2";
export var clickableRow = "_j-5";
export var expandedRow = "_j-7";
export var hoverable = "_j-4";
export var left = "_j-1";
export var right = "_j-3";
export var row = "_j-0";
export var selectedRow = "_j-6";
export var summaryRow = "_j-8";